import { set } from 'Utils/redux';
import { FLIP_MODE_TYPES } from 'Webapp/action-types';

export const setFlipModeEnabled = set(FLIP_MODE_TYPES.SET_ENABLED, 'enabled');
export const setTargetRemoteId = set(
  FLIP_MODE_TYPES.SET_TARGET_REMOTE_ID,
  'targetRemoteId',
);
